const getResizedImageUrl = (url) => {
  const regex = /(\.[a-zA-Z0-9]+)(\?v=\d+)?$/;
  return url.replace(regex, (match, ext, version) => {
    return `_400x${ext}${version || ''}`;
  });
};

const handleNostoApiCall = async (start, append = false, url, querySize) => {
  const startTime = performance.now(); // Start timing

  let searchParams = url.slice(1);
  let sortByValue = null;
  let sortField = "";
  let sortOrder = "";
  let minPrice = "5";
  let maxPrice = "100";
  let customCollection = [];
  let sizes = [];
  let colors = [];
  let bassoms = [];

  // sort by logic
  if (searchParams.trim() != '' && searchParams.includes('&')) {
    let searchItems = searchParams.split('&');
    searchItems.forEach(param => {
      if (param.startsWith("sort_by=")) {
        sortByValue = param.split('=')[1];
      }
      if (param.includes("gte=")) {
        minPrice = param.split('=')[1];
      }
      if (param.includes("lte=")) {
        maxPrice = param.split('=')[1];
      }
      if (param.includes("custom.collection=")) {
        customCollection.push(`[\"${param.split('=')[1]}\"]`);
      }
      // if (param.includes("custom.color_hex=")) {
      //   // colors.push(`${param.split('=')[1].split('%')[0]}`);
      //   const rawValue = decodeURIComponent(param.split('=')[1]); // e.g., "Weiß|#FFFFFF"
      //   const colorName = rawValue.split('|')[0]; // e.g., "Weiß"
      //   colors.push(colorName);
      // }

      if (param.includes("custom.color_hex=")) {
        const colorMap = JSON.parse(
          document.getElementById('color-hex-map').textContent
        );
        document.querySelectorAll('input.color-facet-r').forEach(input => {
          const label = input.getAttribute('value'); // e.g. "Blanc|#FFFFFF" (translated)
          const hex = label.split('|')[1]?.toUpperCase();

          if (hex && colorMap[hex]) {
            input.setAttribute('data-raw', colorMap[hex]); // e.g. "Weiß|#FFFFFF"
          } else {
            input.setAttribute('data-raw', hex); // fallback to just hex
          }
        });
        let rawVal = param.split('=')[1]; // Still URL-encoded
        rawVal = rawVal.replace(/\+/g, ' '); // Replace + with space
        const paramVal = decodeURIComponent(rawVal); // e.g. "Blanc|#FFFFFF"
        const matchingInput = document.querySelector(`input.color-facet-r[value="${paramVal}"]`);

        if (matchingInput) {
          const raw = matchingInput.getAttribute('data-raw'); // "Weiß|#FFFFFF"
          const colorName = raw?.split('|')[0]; // "Weiß"
          console.log(colorName, 'colorName')
          if (colorName) colors.push(colorName);
        } else {
          // fallback if data-raw not found
          console.log('fjjfjjfjf');
          const fallbackColor = paramVal.split('|')[0];
          colors.push(fallbackColor);
        }
      }

      if (param.includes("option.size=")) {
        sizes.push(param.split('=')[1]);
      }
      if (param.includes("custom.booty_passform=")) {
        bassoms.push(`[\"${param.split('=')[1].replace(/\+/g, " ")}\"]`);
      }
    });
  } else if (searchParams.trim() != '') {
    if (searchParams.includes("sort_by=")) {
      sortByValue = searchParams.split("=")[1];
    }
    if (searchParams.includes("custom.collection=")) {
      customCollection.push(`[\"${searchParams.split('=')[1]}\"]`);
    }
    if (searchParams.includes("custom.color_hex=")) {
      colors.push(`${searchParams.split('=')[1].split('%')[0]}`);
    }
    if (searchParams.includes("option.size=")) {
      sizes.push(searchParams.split('=')[1]);
    }
    if (searchParams.includes("custom.booty_passform=")) {
      bassoms.push(`[\"${searchParams.split('=')[1].replace(/\+/g, " ")}\"]`);
    }
  }

  if (sortByValue === "price-ascending") {
    sortField = "price";
    sortOrder = "asc";
  } else if (sortByValue === "price-descending") {
    sortField = "price";
    sortOrder = "desc";
  }

  let filters = [];

  if (customCollection.length > 0) {
    filters.push({
      "field": "customFields.custom-collection",
      "value": customCollection
    });
  }

  if (colors.length > 0) {
    filters.push({
      "field": "extra.color",
      "value": colors
    });
  }

  if (sizes.length > 0) {
    filters.push({
      "field": "skus.customFields.size",
      "value": sizes
    });

    filters.push({
      "field": "skus.availability",
      "value": "InStock"
    });
  }

  if (bassoms.length > 0) {
    filters.push({
      "field": "customFields.custom-booty_passform",
      "value": bassoms
    });
  }

  if (minPrice && maxPrice) {
    filters.push({
      "field": "price",
      "range": [
        {
          "gte": minPrice,
          "lte": maxPrice
        }
      ]
    });
  }

  try {
    
    const response = await new Promise((resolve, reject) => {
      nostojs(api => {
        api.search({
          products: {
            categoryId: window.collection.id,
            facets: ['*'],
            fields: [
              'productId',
              'name',
              'url',
              'imageUrl',
              'price',
              'alternateImageUrls',
              // 'skus.id',
              // 'skus.name',
              // 'skus.availability'
            ],
            sort: sortField !== "" ? [{ field: sortField, order: sortOrder }] : [],
            filter: [{ "all": filters }],
            size: querySize ?? 40,
            from: start
          }
        }, {
          track: 'category',
          redirect: false
        }).then(resolve).catch(reject);
      });
    });

    const productsWrapper = document.querySelector('#product-grid');
    const productLoader = document.querySelector('.loader_element');
    const emptyText = document.querySelector('.title-wrapper__empty');
    const productCountWrapper = document.querySelector('[data-products-count-text]');
    const loadingBtn = document.querySelector('#loading_next .button');


    if (productsWrapper && productLoader && emptyText) {

      const template = document.getElementById('product-card-template')?.content;

      if (response.products.hits.length > 0) {
        if (!append) {
          productsWrapper.innerHTML = '';
        }

        (async () => {
          const products = response.products?.hits || [];
          const resultId = response.result_id;
          const totalResults = response.products?.total || 0;

          const firstVariantIds = products.map(p => p.skus?.[0]?.id).filter(Boolean);
          const productHandles = products.map(p => p.url).filter(Boolean);
          const useHandles = productHandles[0]?.startsWith("https://teveo.com/products");

          const requests = useHandles
            ? productHandles.map(url => {
              const path = new URL(url).pathname;
              const marketUrl = window.routes.root_url.replace(/\/$/, '');
              const newUrl = `${marketUrl}${path}`;
              
              return fetchProductCardHTML(newUrl, 'recommended-products__item', true);
            })
            : firstVariantIds.map(id =>
              fetchProductCardHTMLByFirstVariant(id, 'recommended-products__item')
            );

          const responses = await Promise.all(requests);
          const cardsHtml = responses.join('');

          const parser = new DOMParser();
          const doc = parser.parseFromString(cardsHtml, 'text/html');

          // Update all product links with `?nosto=...`
          doc.querySelectorAll('.product-details__wrapper a').forEach(a => {
            try {
              const url = new URL(a.href);
              url.searchParams.set('nosto', resultId);
              a.href = url.toString();
            } catch (e) {
              console.warn('Invalid product link', a.href);
            }
          });

          // Replace class on root-level product card wrappers
          doc.querySelectorAll('.recommended-products__item').forEach(el => {
            el.classList.remove('recommended-products__item');
            el.classList.add('grid__item');
          });

          const newItems = doc.querySelectorAll('.grid__item');

          // Inject HTML
          if (append) {
            newItems.forEach(item => {
              productsWrapper.appendChild(item);
            });
          } else {
            productsWrapper.innerHTML = '';
            newItems.forEach(item => {
              productsWrapper.appendChild(item);
            });
          }
          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));


          // ✅ Nosto Tracking: Clicks + Add-to-Cart
          newItems.forEach((item, index) => {
            const product = products[index];
            if (!product) return;

            const productId = product.productId;
            const productUrl = product.url;

            // ✅ Track search click on product link
            const link = item.querySelector('a[href*="/products/"]');
            if (link) {
              link.addEventListener('click', () => {
                nostojs(api => {
                  api.recordSearchClick('category', {
                    productId,
                    url: productUrl
                  });
                });
              });
            }

            // ✅ Track add-to-cart clicks only for buttons inside *this* item
            const buttons = item.querySelectorAll('.sizes__wrapper--item:not([disabled]), .size-button:not([disabled])');
            buttons.forEach(button => {
              button.addEventListener('click', () => {
                const variantId = button.dataset.variant || button.dataset.variantId;
                const productHandle = button.dataset.productHandle || button.closest('[data-product-handle]')?.dataset.productHandle;
                const productId = button.dataset.productId || button.closest('[data-product-id]')?.dataset.productId;

                // Fallback to build product URL
                const productUrl = `https://teveo.com/products/${productHandle}`;
                if (productId && productUrl) {
                  nostojs(api => {
                    api.recordSearchAddToCart('category', {
                      productId,
                      url: productUrl
                    });
                  });
                } else {
                  console.warn('Missing productId or productHandle for Nosto AddToCart tracking');
                }
              });
            });

          });


          // quickAddToCart.setSizeListners('#product-grid');
          productLoader.classList.add('hidden');
          productsWrapper.classList.remove('hidden');
          emptyText.classList.add('hidden');
        })();

        if (productCountWrapper && loadingBtn) {
          let currentProducts = response.products.hits.length;
          loadingBtn.setAttribute('data-total', response.products.total);
          loadingBtn.classList.remove('hidden');
          productCountWrapper.classList.remove('hidden');

          if (append) {
            currentProducts = parseInt(loadingBtn.getAttribute('data-hits') || '0') + response.products.hits.length;
            loadingBtn.classList.remove('loading-products');
            loadingBtn.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
          }

          loadingBtn.setAttribute('data-hits', currentProducts);

          const productCountsText = {
            '{{total_products}}': response.products.total,
            '{{current_products}}': currentProducts
          };

          if (currentProducts === response.products.total) {
            loadingBtn.classList.add('hidden');
          }

          productCountWrapper.querySelector('span').innerHTML = productCountWrapper.dataset.productsCountText.replace(
            /{{total_products}}|{{current_products}}/gi,
            matched => productCountsText[matched]
          );

          initButtons();
        }
      } else {
        productLoader.classList.add('hidden');
        emptyText.classList.remove('hidden');
        if (loadingBtn) loadingBtn.classList.add('hidden');
        if (productCountWrapper) productCountWrapper.classList.add('hidden');
      }
    }

    const endTime = performance.now(); // End timing
    const duration = endTime - startTime; // Calculate duration
    console.log(`handleNostoApiCall took ${duration} ms to fully load the products`);
  } catch (error) {
    console.log("Nosto Logs: ", error);
  }
};
// This is the initial load of the collection, it is a mess if at some point there are more than one instance in the same page.
handleNostoApiCall(0, false, window.location.search ,window.nostoNewCardsCollectionSize || 40);